import { TLink } from '../../../types/utils/link';

export const getValidLinkUrl = (link: TLink) =>
  link?.cached_url?.replace(/\s/g, '').length > 0 ? link.cached_url : '/';
